import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function CategoryNav() {
  return (
    <section className="py-8 md:py-10 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-2 mb-5">
          <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">分类导航</h2>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100 hover:bg-primary-50 transition-colors border border-background-200/60 hover:border-primary-200"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}